// extracted by mini-css-extract-plugin
export var privacyBlock = "styles-module--privacyBlock--qSM9z";
export var privacyBlockText = "styles-module--privacyBlock-text--NIKCR";
export var privacyBlockSubTitle = "styles-module--privacyBlock-subTitle--K1oFt";